/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmTokenItemSummaryInfo } from './EvmTokenItemSummaryInfo';
import type { EvmTokenSummaryInfo } from './EvmTokenSummaryInfo';

export type SomniaAccountPortfolioNftInfo = {
    TSI: EvmTokenSummaryInfo;
    TISI: EvmTokenItemSummaryInfo;
    TKNT: SomniaAccountPortfolioNftInfo.TKNT;
    QTY: string;
};

export namespace SomniaAccountPortfolioNftInfo {

    export enum TKNT {
        NA = 'NA',
        CA = 'CA',
        ERC20 = 'ERC20',
        ERC721 = 'ERC721',
        ERC1155 = 'ERC1155',
    }


}

